import { AppPermission, PermissionKey } from 'shared/types';

export const PERMISSIONS: Record<PermissionKey, AppPermission> = {
  login: 'wps.login',
  manager: 'wps.manager',
  insight: 'wps.insight',
};
